import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import { setCurrentTenantConfig } from '..'

type ConfigurationSetterProps = {
  tenantId: string
  projectId?: string
}

export const ConfigurationSetter: React.FC<ConfigurationSetterProps> = ({
  tenantId,
  projectId,
}) => {
  useEffect(() => {
    setCurrentTenantConfig({ tenantId, projectId })
  }, [tenantId, projectId])

  return <Navigate to="/" />
}
